var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83927 5.28218C11.9682 4.23853 15.1301 6.19849 16.0084 9.37175C16.6068 11.5341 16.04 13.8014 14.658 15.354C14.941 15.7206 15.2503 16.0731 15.5861 16.4091C15.9202 16.7435 16.2706 17.0516 16.6349 17.3337C18.1869 15.9407 20.4611 15.3676 22.6297 15.9687C25.8023 16.8481 27.7586 20.0124 26.7166 23.1412C26.0329 25.1941 24.758 26.4414 23.0578 26.8519C21.4779 27.2334 19.7745 26.8279 18.2721 26.2034C15.2462 24.9455 12.2583 22.4678 10.8937 21.1022C9.49697 19.7044 7.02998 16.7122 5.78352 13.692C5.16455 12.1922 4.76601 10.4951 5.14838 8.92248C5.55976 7.23057 6.8007 5.96209 8.83927 5.28218ZM13.5143 10.062C12.9803 8.13269 11.206 7.22073 9.65808 7.73705C8.29741 8.19087 7.82547 8.8655 7.66295 9.53389C7.47144 10.3216 7.63797 11.402 8.17564 12.7047C9.24243 15.2896 11.4549 18.0026 12.7243 19.273C13.963 20.5126 16.6732 22.7362 19.2655 23.8138C20.5722 24.357 21.6579 24.5278 22.4504 24.3364C23.1224 24.1741 23.8031 23.6994 24.2613 22.3235C24.7781 20.7719 23.8646 18.9964 21.9384 18.4625C20.5049 18.0651 19.0311 18.5255 18.154 19.4649C17.5876 20.0715 16.5079 20.4173 15.5893 19.7761C14.9429 19.3249 14.3291 18.8122 13.7555 18.2383C13.1811 17.6634 12.6682 17.0481 12.217 16.4003C11.5798 15.4856 11.9198 14.4101 12.522 13.8424C13.4544 12.9633 13.9102 11.4927 13.5143 10.062Z",
    fill: "#252C32",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.622c4df32fefcbce9a0a513d75676804.svg";
export { ForwardRef as ReactComponent };